import { useRouter } from 'next/router'
import * as qs from 'query-string'
import { FC } from 'react'

import { Media, TextLink } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { useReviewsProductGroupDataContext } from '../../../../../containers/ReviewsProductGroupDataService/useReviewsProductGroupData'
import { MaybeSpaLinkWrapper } from '../../../../../lib/adapters/next-routing-service/MaybeSpaLinkWrapper'
import { useKitHref, useProductHref } from '../../../../../lib/routing'
import { singleQueryParamValue } from '../../../../../lib/utils'
import { WriteReviewButton } from '../WriteReviewButton'

import { HeaderItem, HeaderWrapper, Title } from './styles'

export const ReviewHeader: FC<{
  reviewSubmitted: boolean
  onWriteReview: () => void
}> = ({ reviewSubmitted, onWriteReview }) => {
  const {
    magnolia: {
      reviewsPage: { headline, backToKit, backToProduct },
    },
  } = useTranslation()

  const { results } = ProductReviewsContainer.useContainer()
  const { data: productData } = useReviewsProductGroupDataContext()
  const total = results?.totalReviews ?? 0

  const router = useRouter()
  const kitHandle = singleQueryParamValue(router.query.kit, '')
  const showBackLabel = qs.parseUrl(router.asPath).query?.plain !== 'true'
  const backLabel = kitHandle ? backToKit : backToProduct

  const kitHref = useKitHref(kitHandle)
  const productHref = useProductHref(productData?.productGroupHandle ?? '', {
    color: productData?.colorId,
  })
  const href = kitHandle ? kitHref : productHref

  const showWriteAReviewAction = total > 0

  return (
    <>
      <HeaderWrapper>
        {showBackLabel && (
          <HeaderItem>
            <MaybeSpaLinkWrapper href={href}>
              <TextLink as='a' href={href} variant='left-arrow'>
                {backLabel}
              </TextLink>
            </MaybeSpaLinkWrapper>
          </HeaderItem>
        )}

        <Media greaterThanOrEqual='md'>
          <HeaderItem>
            <Title>{headline}</Title>
          </HeaderItem>
        </Media>

        <HeaderItem isVisible={showWriteAReviewAction}>
          <Media greaterThanOrEqual='md'>
            <WriteReviewButton
              disabled={reviewSubmitted || !showWriteAReviewAction}
              onClick={onWriteReview}
              variant='filled'
            />
          </Media>
          <Media lessThan='md'>
            <WriteReviewButton
              disabled={reviewSubmitted || !showWriteAReviewAction}
              onClick={onWriteReview}
              variant='black-on-white-no-border'
            />
          </Media>
        </HeaderItem>
      </HeaderWrapper>

      <Media lessThan='md'>
        <Title>{headline}</Title>
      </Media>
    </>
  )
}
